export default function moveToArticle (link) {
  window.location.href = link;
}
//add if total product price goes over 50 waive the shipping cost